/*eslint-disable */
import EditUser from './EditUser';

export default EditUser;
